import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';
import { Resolvers } from '@apollo/client/core'
import { Category } from '../../models/categories/category';

@Injectable({
  providedIn: 'root'
})
export class GetStorefrontCategoriesGQL extends Query<GetStorefrontCategoriesGQLResponse, GetStorefrontCategoriesGQLVariables> {
  document = gql`
  query getCategories($storefrontId: ID!) {
    storefronts(storefrontIds: [$storefrontId]) {
      partnerId
      catalog {
        catalogId
        name
        categories {
          productCount @client
          categoryId
          name
          position
          isAffiliate
          products {
            productId
          }
        }
      }
    }
  }`;
}

interface GetStorefrontCategoriesGQLVariables {
  storefrontId: string;
}

interface GetStorefrontCategoriesGQLResponse {
  storefronts: StorefrontCatalogResponse[];
}

interface CategoryQuery {
  name: string;
  position: number;
  products: {
    productId: string;
  }[];
}

export interface StorefrontCatalogResponse {
  partnerId: number;
  catalog: CatalogWithCategories;
}

export interface CatalogWithCategories {
  name: string;
  catalogId: string;
  categories: StorefrontCategory[];
}

export type StorefrontCategory = Pick<Category, 'categoryId' | 'name' | 'position' | 'isAffiliate'> & { productCount: number };

export const CategoryCountResolver: Resolvers = {
  Category: {
    productCount(cat: CategoryQuery) {
      return cat.products.length;
    }
  }
};
